import React, {
  useCallback,
  useContext,
  useEffect,
  useMemo,
  useRef,
  useState,
} from "react";
import Cookies from "js-cookie";
import { FetchDataTypes } from "../../api/api";
import { Line } from "react-chartjs-2";
import { AgGridReact } from "ag-grid-react";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-alpine.css";
import {
  Chart,
  ArcElement,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
  PointElement,
  LineElement,
  Filler,
} from "chart.js";
import { Pagination } from "../../components";
import {
  formateDatabuyCurr,
  formateDataCurr,
  formateDataPrec,
} from "../../utils/types";
import clsx from "clsx";
import _ from "lodash";
import { Grid, GridReadyEvent } from "ag-grid-community";
import "ag-grid-enterprise";
import { CsvExportModule } from "@ag-grid-community/csv-export";
import { ModuleRegistry } from "@ag-grid-community/core";
import { ClientSideRowModelModule } from "@ag-grid-community/client-side-row-model";
import { ExcelExportModule } from "@ag-grid-enterprise/excel-export";
import { MenuModule } from "@ag-grid-enterprise/menu";
import "react-tabs/style/react-tabs.css";
import jsPDF from "jspdf";
import "jspdf-autotable";
import autoTable, { UserOptions } from "jspdf-autotable";

Chart.register(
  ArcElement,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
  PointElement,
  LineElement,
  Filler
);
export interface IOlympicData {
  symbol: string;
  date: any;
  status: string;
  order: string;
  qty: string;
  price: number;
}
interface jsPDFCustom extends jsPDF {
  autoTable: (options: UserOptions) => void;
}
// Register the required feature modules with the Grid
ModuleRegistry.registerModules([
  ClientSideRowModelModule,
  CsvExportModule,
  ExcelExportModule,
  MenuModule,
]);

function FundStatement({ title }: any) {
  const dataGridRef = useRef<AgGridReact<IOlympicData>>(null);
  const dataGridRefMain = useRef<AgGridReact<IOlympicData>>(null);
  const securityDataGridRef = useRef<AgGridReact<IOlympicData>>(null);
  const [sectorAllocation, setSectorAllocation] = useState<any>(null);
  const [sectorDetails, setSectorDetails] = useState<any>(null);
  const [sectorCount, setSectorCount] = useState<any>(null);
  const [SectorCurrentPage, setSectorCurrentPage] = useState(1);
  const [showModal, setShowModal] = useState("hide");
  const [selectedData, setSelectedData] = useState<any>(null);
  const [securityActivity, setSecurityActivity] = useState<any>([]);
  const [filteredData, setFilteredData] = useState<any>([]);
  const [tabIndex, setTabIndex] = useState(0);
  const [selected, setSelected] = useState<any>([]);
  const [selectedSecurity, setSelectedSecurity] = useState<any>(null);

  // useEffect(() => {
  //   FetchDataTypes("FundStatement", Cookies.get("newJwt"))
  //     .then((response) => response.json())
  //     .then((response) => {
  //       setSectorAllocation(response);
  //     });
  // }, []);

  const selectedClient: any = Cookies.get("client");
  const onGridReady = useCallback((params: GridReadyEvent) => {
    FetchDataTypes(
      "FundStatementValues",
      parseInt(selectedClient),
      Cookies.get("newJwt")
    )
      .then((response) => response.json())
      .then((response) => {
        setSectorDetails(response);
        setSectorCount(response);
      });
  }, []);

  const newOnGridReady = useCallback((params: GridReadyEvent) => {
    FetchDataTypes(
      "SecurityActivity",
      parseInt(selectedClient),
      Cookies.get("newJwt")
    )
      .then((response) => response.json())
      .then((response) => {
        setSecurityActivity(response);
      });
  }, []);

  const SectorpageHandler = (pageNumbers: any, index: any) => {
    setSectorDetails(
      sectorCount.slice(pageNumbers * 20 - 20, pageNumbers * 20)
    );
    setSectorCurrentPage(pageNumbers);
  };

  function currencyFormat(num: any) {
    return num.toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
  }
  function formateAsPercent(num: any) {
    return new Intl.NumberFormat("default", {
      style: "percent",
      minimumFractionDigits: 0,
      maximumFractionDigits: 2,
    }).format(num / 100);
  }

  let security = [];
  security.push(
    sectorDetails?.map((e: any) => {
      return { label: e.sectorName, value: e.sectorName };
    })
  );

  const autoGroupColumnDef = useMemo(() => {
    return {
      minWidth: 200,
    };
  }, []);
  const FundStatementColumnDefs = [
    {
      field: "fundName",
      headerName: "Fund Name",
      resizable: true,
      cellClass: "cell-wrap-text",
      flex: 1,
    },
    {
      field: "beginningBalance",
      headerName: "Market Value",
      flex: 1,
      cellClass: "cell-wrap-text textAlign",
      cellRenderer: formateDataCurr,
      headerClass: "headerTextAlign",
    },
    {
      field: "contributions",
      headerName: "Contributions",
      cellRenderer: formateDatabuyCurr,
      flex: 1,
      cellClass: "cell-wrap-text textAlign",
      headerClass: "headerTextAlign",
    },
    {
      field: "redemptions",
      headerName: "Redemptions",
      cellRenderer: formateDataCurr,
      flex: 1,
      cellClass: "cell-wrap-text textAlign",
      headerClass: "headerTextAlign",
    },
    {
      field: "income",
      headerName: "Income",
      cellRenderer: formateDataCurr,
      flex: 1,
      cellClass: "cell-wrap-text textAlign",
      headerClass: "headerTextAlign",
    },
    {
      field: "expenses",
      headerName: "Expenses",
      cellRenderer: formateDataCurr,
      flex: 1,
      cellClass: "cell-wrap-text textAlign",
      headerClass: "headerTextAlign",
    },
    {
      field: "other",
      headerName: "Other",
      flex: 1,
      cellRenderer: formateDataCurr,
      cellClass: "cell-wrap-text textAlign",
      headerClass: "headerTextAlign",
    },
    {
      field: "realGainLoss",
      headerName: "Real G/L",
      flex: 1,
      cellRenderer: formateDataCurr,
      cellClass: "cell-wrap-text textAlign",
      headerClass: "headerTextAlign",
    },
    {
      field: "unrealGainLoss",
      headerName: "Unreal G/L",
      flex: 1,
      cellRenderer: formateDataCurr,
      cellClass: "cell-wrap-text textAlign",
      headerClass: "headerTextAlign",
    },
    {
      field: "endingBalance",
      headerName: "Ending Balance",
      flex: 1,
      cellRenderer: formateDataCurr,
      cellClass: "cell-wrap-text textAlign",
      headerClass: "headerTextAlign",
    },
  ];

  function getRowData(e: any) {
    setSelectedData(e.data);
    setTabIndex(1);
  }

  useEffect(() => {
    setFilteredData(
      selectedData?.sectorName
        ? _.filter(securityActivity, { sectorName: selectedData?.sectorName })
        : _.filter(securityActivity, (securityActivity) =>
            _.map(selected, "value").includes(securityActivity?.sectorName)
          )
    );
  }, [securityActivity, selected, selectedData?.sectorName]);

  const onBtExportMain = useCallback(() => {
    const params = {
      processCellCallback: (params: any) => {
        if (params.column.colId === "dateColumn") {
          // Format date as desired
          return params.value
            ? new Date(params.value).toLocaleDateString()
            : "";
        }
        if (typeof params.value === "string") {
          // Apply currency symbol to string values
          return `${params.value}`;
        }
        if (typeof params.value === "number") {
          // Format numbers as currency with the currency symbol
          return `$${params.value.toFixed(2)}`;
        }
        return params.value !== null ? `$${params.value}` : "--";
      },
    };

    dataGridRefMain.current?.api.exportDataAsExcel(params);
  }, []);

  const exportFundStatementData = () => {
    const unit = "pt";
    const size = "A4"; // Use A1, A2, A3 or A4
    const orientation = "landscape"; // portrait or landscape

    const marginLeft = 40;
    const doc = new jsPDF(orientation, unit, size) as jsPDFCustom;

    doc.setFontSize(8);

    const title = "Fund Statement";
    const headers = [
      [
        "Fund Name",
        "Market Value",
        "Contributions",
        "Redemptions",
        "Income",
        "Expenses",
        "Other",
        "Real G/L",
        "Unreal G/L",
        "Ending Balance",
      ],
    ];

    const data = sectorDetails.map((e: any) => [
      e.fundName,
      `$${e.beginningBalance}`,
      `$${e.beginningBalance}`,
      `$${e.contributions}`,
      `$${e.redemptions}`,
      `$${e.income}`,
      `$${e.expenses}`,
      `$${e.other}`,
      `$${e.realGainLoss}`,
      `$${e.unrealGainLoss}`,
      `$${e.endingBalance}`,
    ]);

    let content = {
      startY: 50,
      head: headers,
      body: data,
    };

    doc.text(title, marginLeft, 40);
    doc.autoTable(content);
    doc.save("FundStatement.pdf");
  };

  const [gridHeight, setGridHeight] = useState("auto");
  const rowHeight = 30; // set the row height
  const rowCount = sectorDetails?.length; // get the row count

  useEffect(() => {
    const newHeight = `${rowHeight * rowCount + 140}px`; // calculate the grid height
    setGridHeight(newHeight); // set the grid height
  }, [rowCount]);
  // const onBtExportMain = useCallback(() => {
  //   dataGridRefMain.current!.api.exportDataAsExcel();
  // }, []);

  return (
    <>
      {sectorDetails?.length !== 0 ? (
        <div className="card w-100">
          <div className="col-sm-3 w-100 d-flex pt-3 justify-content-between tableFilters px-4">
            <h5 className="card-title float-start">{title ? title : "Fund Statement"}</h5>
            <div className="col-sm-2 my-3 text-end">
              <i
                className="align-middle me-2 far fa-fw fa-file-excel cursor-pointer"
                style={{ fontSize: "16px" }}
                onClick={onBtExportMain}
              ></i>
              <i
                className="align-middle me-2 far fa-fw fa-file-pdf cursor-pointer"
                onClick={() => exportFundStatementData()}
                style={{ fontSize: "16px" }}
              ></i>
            </div>
          </div>
          <div className="card-body">
            <div className="chart chart-xs">
              <div className="chartjs-size-monitor">
                <div className="chartjs-size-monitor-shrink">
                  <div className="row">
                    <div
                      className="ag-theme-alpine"
                      style={{
                        height: gridHeight,
                        width: "100%",
                        maxHeight: "550px",
                      }}
                    >
                      <AgGridReact
                        ref={dataGridRefMain}
                        rowData={sectorDetails}
                        columnDefs={FundStatementColumnDefs}
                        onRowClicked={getRowData}
                        onGridReady={onGridReady}
                        pagination={true}
                        paginationPageSize={20}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      ) : null}
    </>
  );
}

export { FundStatement };
